import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer';
import { useLanguage } from '../../contexts/LanguageContext';

const SuccessPage = () => {
  const { t } = useLanguage();
  const copy = t('successPage', {});
  const steps = Array.isArray(copy.nextSteps) ? copy.nextSteps : [];
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-prayer-red via-purple-600 to-blue-600 flex items-center justify-center px-4">
        <div className="max-w-lg w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
          {/* Logo and Header */}
          <h1 className="text-xl font-bold text-prayer-red mb-6">
            {t('brand.shortName')}
          </h1>

          {/* Success Icon */}
          <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <svg 
              className="w-10 h-10 text-green-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          </div>

          {/* Success Message */}
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {copy.title}
          </h2>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            {copy.subtitle}
          </p>

          {/* Key Benefits */}
          <div className="bg-prayer-red/5 border border-prayer-red/20 rounded-lg p-6 mb-6 text-left">
            <h3 className="font-semibold text-prayer-red mb-4 text-center">{copy.whatsNext}</h3>
            <ul className="space-y-3 text-sm text-gray-700">
              {steps.map((step) => (
                <li key={step} className="flex items-center">
                  <svg className="w-5 h-5 text-prayer-red mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  {step}
                </li>
              ))}
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleReturnHome}
              className="w-full bg-prayer-red text-white py-3 px-6 rounded-lg font-semibold hover:bg-prayer-red-light transition-all duration-200 shadow-lg"
            >
              {copy.backToHome}
            </button>
            
            <button
              onClick={() => navigate('/auth/login')}
              className="w-full bg-white border-2 border-prayer-red text-prayer-red py-3 px-6 rounded-lg font-semibold hover:bg-prayer-red/5 transition-all duration-200"
            >
              {copy.signInToAccount}
            </button>
          </div>

          {/* Footer Message */}
          <p className="text-sm text-gray-500 mt-6">
            {copy.footerMessage}
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SuccessPage;
